<template>
  <v-layout row wrap my-3 mx-2>
    <v-flex xs12 px-2>
      <v-card v-if="!generated" class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Generate a short link
        </v-card-title>
        <v-layout row wrap px-2 pt-3>
          <v-flex xs12 md3>
          </v-flex>
          <v-flex xs12 md6 px-1>
            <v-layout row wrap>
              <v-flex xs8 px-2>
                <v-text-field
                  label="Long URL"
                  v-model="longUrl"
                  :error-messages="longUrlErrors"
                  @blur="$v.longUrl.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 px-2>
                <v-btn :disabled="!longUrl" :loading="loading" @click="genLink()" block color="primary" >generate</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md3>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-if="generated" class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Generated: {{ shortURL }}
        </v-card-title>
        <v-layout row wrap px-2 pt-3>
          <v-flex xs8 px-1>
            <v-text-field
              solo
              readonly
              label="Short Url"
              v-model="shortURL"
            ></v-text-field>
          </v-flex>
          <v-flex xs4 px-1>
            <v-btn
              v-clipboard:copy="shortURL"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              block color="primary" dark>
              <v-icon>file_copy</v-icon>
            </v-btn>
          </v-flex>
          
        </v-layout>
        <v-divider></v-divider>
        <v-expansion-panel expand>
          <v-expansion-panel-content>
            <div slot="header">Settings & Customization</div>
            <v-layout row wrap px-1>
              <v-flex xs12 md4 px-1>
                <v-text-field
                  prefix="/"
                  label="Short UID"
                  v-model="uid"
                  :error-messages="errors"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-btn @click="check()" fab small :loading="loading" block color="primary" dark>
                  <v-icon>save</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 md4 px-1>
                <span class="red--text">{{error}}</span>
              </v-flex>
              <v-flex xs6 md4 px-1>
                <v-text-field
                  label="UTM Campaign"
                  v-model="campaign"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4 px-1>
                <v-text-field
                  label="UTM Content"
                  v-model="content"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4 px-1>
                <v-text-field
                  label="UTM Referrer"
                  v-model="referrer"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-btn @click="check()" :loading="loading" block color="primary" dark>Update</v-btn>
              </v-flex>
              <v-flex xs12 md4 pa-2>
                <span class="success--text">{{ success }}</span>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate'
import { required, url } from 'vuelidate/lib/validators'
import { storageRef, firebase, db, auth } from '@/fb';


export default {
  mixins: [validationMixin],
  data() {
    return {
      loading:false,
      longUrl:null,
      generated:false,
      shortURL:null,
      uid:null, 
      firstUid:null,
      campaign:null,
      content:null,
      referrer:null,
      success:null,
      error:null,
      errors:[],
    }
  },
  methods: {
    checkDB(){
      return db.ref(`shortlinks/${this.uid}`)
        .once('value')
        .then(x=>{
          return x.val()
        })
    },
    check(){
      this.error = null
      this.errors = []
      this.success = null
      if (this.firstUid !== this.uid) {
        this.checkDB().then(x=>{
          if(!x){
            this.updateShort()
          } else {
            this.error = `${this.uid} is already take, please try another`
            this.$emit('snackbarNotification', `${this.uid} is already take, please try another`, 'error')
            this.errors.push(this.error)
          }
        })
      } else {
        this.updateShort()
      }
    },
    updateShort(){
      this.loading = true
      db.ref(`shortlinks/${this.firstUid}`)
      .once('value')
      .then(snap=>{
        let linkD = snap.val()
        let d = {
          campaign:this.campaign,
          content:this.content,
          referrer:this.referrer,
        }
        let newLinkD = Object.assign(linkD, d)
        db.ref(`shortlinks/${this.uid}`)
        .update(newLinkD)
        .then(x=>{
          if (this.firstUid !== this.uid) {
            db.ref(`shortlinks`)
            .update({[this.firstUid]:null})
            .then(x=>{
              this.firstUid = this.uid
              this.shortURL = `https://ltl.im/${this.uid}`
              this.loading = false
              this.$emit('snackbarNotification', `Updated Successfully`, 'success')
              this.success = `Updated Successfully`
            })
          } else {
            this.loading = false
            this.$emit('snackbarNotification', `Updated Successfully`, 'success')
            this.success = `Updated Successfully`
          }
        })
      })
    },
    genLink(){
      this.loading = true
      let d = {
        url:this.longUrl
      }
      var headers = {
        'Accept': 'application/json'
      }
      axios.post('//ltl.im/api/', d, {headers: headers})
      .then(resp=>{
        this.generated = true
        this.loading = false
        this.firstUid = resp.data.linkId
        this.uid = resp.data.linkId
        this.shortURL = `https://ltl.im/${this.uid}`
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
  },
  computed:{
    longUrlErrors () {
      const errors = []
      if (!this.$v.longUrl.$dirty) return errors
      !this.$v.longUrl.url && errors.push('Please enter a valid URL')
      !this.$v.longUrl.required && errors.push('URL is required')
      return errors
    },
  },
  validations: {
    longUrl: {
      required,
      url
    },
  }
}
</script>

<style scoped>

</style>

